import { Badge } from '@navegasistemas/dls-navega-rjs'
import type { ExportStatus } from '@/features/file-exports/types/export-job.types'

const STATUS_CONFIG: Record<
  ExportStatus,
  { label: string; variant: 'default' | 'warning' | 'success' | 'danger' | 'primary' | 'info' }
> = {
  pending: { label: 'Aguardando', variant: 'default' },
  processing: { label: 'Processando', variant: 'warning' },
  completed: { label: 'Concluído', variant: 'success' },
  failed: { label: 'Falhou', variant: 'danger' },
}

export interface ExportStatusBadgeProps {
  status: ExportStatus
}

export function ExportStatusBadge({ status }: ExportStatusBadgeProps) {
  const config = STATUS_CONFIG[status]
  return <Badge variant={config.variant}>{config.label}</Badge>
}
